var { Pass, ShowText, Title, Cond, Option, Seq, Par, Choice, Select, EmptyProcess } = require("./Processes");
var _ = require("lodash");

/**
 * simplifyProcess(proc) removes EmptyProcess from Seq/Par/Choice
 * and flattens Seq/Par/Choice expessions.
 * It preserves PLabel/PLock/MarkForm/CollectSumFormItems/FlattenForm.
 * This transformation is save, i.e. it guarantees preserving semantic.
 */
function simplifyProcess(proc) {
  switch(proc.type) {
    case "Seq":
        if(!(proc.subprocesses instanceof Array)) return proc;
        var a = proc.subprocesses
          .map(simplifyProcess)
          .filter(function(pr) { return pr.type != "EmptyProcess"; })
          .map(function (pr) {
            return pr.type == "Seq" && pr.subprocesses instanceof Array ? pr.subprocesses : [pr];
          })
          .flat();
        switch(a.length) {
          case 0:  return EmptyProcess;
          case 1:  return simplifyProcess(a[0]);
          default: return Seq(a);
        }
    case "Par":
    case "Choice":
        var a = proc.subprocesses
          .map(simplifyProcess)
          .filter(function(pr) { return pr.type != "EmptyProcess"; });
        switch(a.length) {
          case 0: return EmptyProcess;
          case 1:
            if(proc.caption === undefined)
              return simplifyProcess(a[0]);
          default: return window[proc.type](a, proc.caption);
          // for those who do not understand this notation:
          // proc.type is "Par" or "Choice"
          // window[proc.type] is Par or Choice, correspondingly
          // alternative: eval(proc.type)
        }
    case "PLabel":
    case "PLock":
        return window[proc.type](proc.label, simplifyProcess(proc.process));
    case "MarkForm":
    case "CollectSumFormItems":
    case "FlattenForm":
        var p = _.clone(proc);
        p.subprocess = simplifyProcess(p.subprocess);
        return p;
  }
  return proc;
};

module.exports = simplifyProcess;
